
import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Menu, X, ExternalLink, Shield, LogOut } from 'lucide-react';
// import { useAdminAuth } from '@/contexts/AdminAuthContext';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  // const { isAdminAuthenticated, logout } = useAdminAuth();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const navItems = [
    { label: 'Início', id: 'hero' },
    { label: 'Serviços', id: 'services' },
    { label: 'Sobre', id: 'about' },
    { label: 'Recuperação', id: 'tax-recovery' },
    { label: 'Depoimentos', id: 'testimonials' },
    { label: 'Agendar', id: 'scheduling' }
  ];


  const handleMeiLinkClick = () => {
    window.open('https://www8.receita.fazenda.gov.br/SimplesNacional/Aplicacoes/ATSPO/pgmei.app/Identificacao', '_blank');
    setIsMobileMenuOpen(false);
  };

  const handleCalculadoraClick = () => {
    window.open('https://piloto-cbs.tributos.gov.br/servico/calculadora-consumo/calculadora', '_blank');
    setIsMobileMenuOpen(false);
  };

  // const handleAdminClick = () => {
  //   if (isAdminAuthenticated) {
  //     window.location.href = '/admin';
  //   } else {
  //     window.location.href = '/admin/login';
  //   }
  //   setIsMobileMenuOpen(false);
  // };

  // const handleLogout = () => {
  //   logout();
  //   setIsMobileMenuOpen(false);
  // };

  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-white/95 backdrop-blur-sm'
      }`}
    >
      <nav className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <motion.div
            whileHover={{ scale: 1.05 }}
            className="flex items-center gap-3 cursor-pointer"
            onClick={() => scrollToSection('hero')}
          >
            <img
              src="/images/talclogo.jpg"
              alt="TALC Assessoria Contábil Logo"
              className="h-20 w-auto object-contain"
            />
          </motion.div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-6">
            {navItems.map((item, index) => (
              <motion.button
                key={item.id}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => scrollToSection(item.id)}
                className="text-gray-700 hover:text-[#c99b36] font-medium transition-colors duration-200"
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                {item.label}
              </motion.button>
            ))}
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={handleCalculadoraClick}
              className="bg-[#2a6b5c] hover:bg-[#1e4d3f] text-white px-4 py-2 rounded-lg font-bold flex items-center gap-2 transition-all duration-200 shadow-md hover:shadow-lg"
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: navItems.length * 0.1 }}
            >
              Calculadora
              <ExternalLink className="w-4 h-4" />
            </motion.button>
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={handleMeiLinkClick}
              className="bg-[#c99b36] hover:bg-[#b0862b] text-white px-4 py-2 rounded-lg font-bold flex items-center gap-2 transition-all duration-200 shadow-md hover:shadow-lg"
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: (navItems.length + 1) * 0.1 }}
            >
              Guia MEI
              <ExternalLink className="w-4 h-4" />
            </motion.button>
            {/* Admin button removed */}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-[#0a4b3c] p-2"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden mt-4 pb-4 border-t border-gray-100 pt-4"
          >
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="block w-full text-left py-3 text-gray-700 hover:text-[#c99b36] hover:bg-gray-50 px-4 rounded transition-colors duration-200 font-medium"
              >
                {item.label}
              </button>
            ))}
            <button
              onClick={handleCalculadoraClick}
              className="block w-full text-left py-3 bg-[#2a6b5c] hover:bg-[#1e4d3f] text-white px-4 rounded transition-colors duration-200 font-bold mt-2 flex items-center justify-center gap-2"
            >
              Calculadora
              <ExternalLink className="w-4 h-4" />
            </button>
            <button
              onClick={handleMeiLinkClick}
              className="block w-full text-left py-3 bg-[#c99b36] hover:bg-[#b0862b] text-white px-4 rounded transition-colors duration-200 font-bold mt-2 flex items-center justify-center gap-2"
            >
              Guia MEI
              <ExternalLink className="w-4 h-4" />
            </button>
            {/* Admin button removed (mobile) */}
          </motion.div>
        )}
      </nav>
    </motion.header>
  );
};

export default Header;
